import { render } from "./MainAreas.vue?vue&type=template&id=186284fe&scoped=true"
import script from "./MainAreas.vue?vue&type=script&scoped=true&lang=js"
export * from "./MainAreas.vue?vue&type=script&scoped=true&lang=js"

import "./MainAreas.vue?vue&type=style&index=0&id=186284fe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186284fe"]])

export default __exports__